export default __webpack_public_path__ + "static/media/pic6.e14c2dd6.svg";